export function getObjectToStringMatrix(obj: any[]): Array<any[]> {
  const newArray: Array<any[]> = [];

  obj.forEach((element: any) => {
    newArray.push(Object.values(element));
  });

  return newArray;
}
